import { useState } from "react";
import DebouncedInput from "../../Components/Inputs/DebouncedInput";
import {
  Spinner,
  TablePlaceHolder,
} from "../../Components/LoadingAnimations/LoadingAnimations";
import { PageLayout } from "../../Components/PageLayout";
import { usePaginatedQuery } from "../../Hooks/usePaginatedQuery";
import { convertToPST } from "../../Helper/FormatDatetimes";
import { GetVehicleCondition } from "../../Components/Tables/Vehicles/GetVehicleCondition";
import { TableNavigation } from "../../Components/Tables/Vehicles/TableNavigation";
import { TableFilter } from "../../Components/Inputs/TableFilter";
import { useTranslation } from "react-i18next";
import instance from "../../Interceptor/api_instance";
import { useNavigate } from "react-router-dom";

const DEFAULT_URL =
  "safety/maintenance-tasks/?page_size=50&group_by_report=false";
const MaintenanceTasksView = () => {
  const { state, dispatch, setPage } = usePaginatedQuery(DEFAULT_URL);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [filters, setFilters] = useState({
    description: "",
    start_date: "",
    end_date: "",
    group_by_report: "false",
  });
  const [isLoading, setIsLoading] = useState(false);

  const headers = [
    t("yard-tables.table-columns.description"),
    t("general.unit"),
    `${t("forms.type.maintenance-report.labels.order")} #`,
    t("forms.type.maintenance-report.labels.created-at"),
    t("forms.type.maintenance-report.labels.completed-date"),
    t("yard-tables.table-columns.status"),
    t("yard-tables.table-columns.assigned-to"),
    t("forms.type.vehicle.input-headers.notes"),
  ];
  const handleFilter = (name, value) => {
    // derive the next filters snapshot
    const nextFilters = { ...filters };
    if (value === null || value === "" || value === undefined) {
      delete nextFilters[name]; // remove empty filters
    } else {
      nextFilters[name] = value;
    }

    // update state and navigate using the SAME snapshot
    setFilters(nextFilters);
    const queryParams = new URLSearchParams();
    Object.entries(nextFilters).forEach(([key, val]) => {
      queryParams.append(key, val);
    });
    const queryString = queryParams.toString();
    const url = `${DEFAULT_URL}&${queryString}`;
    setPage(url);
  };

  const handleExport = async () => {
    try {
      setIsLoading(true);
      const data = {
        description: filters.description || null,
        start_date: filters.start_date || null,
        end_date: filters.end_date || null,
      };
      const res = await instance.post("files/export-maintenance-tasks/", data);
      if (res.status === 201) {
        navigate("/export-jobs");
      }
    } catch (err) {
      console.error("Export failed:", err);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <PageLayout title="Tasks History" header="tasks-history">
      <div className="search-filters-cont">
        <div className="search-filters">
          <DebouncedInput
            state={filters.description}
            setState={handleFilter}
            label={"description"}
            name={"description"}
          />
          <TableFilter
            label={"startDate"}
            inputType={"date"}
            name={"start_date"}
            value={filters.start_date || ""}
            onChange={(e) => handleFilter("start_date", e.target.value)}
          />
          <TableFilter
            label={"endDate"}
            inputType={"date"}
            name={"end_date"}
            value={filters.end_date || ""}
            onChange={(e) => handleFilter("end_date", e.target.value)}
          />
          {isLoading ? (
            <Spinner />
          ) : (
            <button className="change-pwd-btn" onClick={handleExport}>
              {t("buttons.export")}
            </button>
          )}
        </div>
        <TableNavigation state={state} dispatch={dispatch} />
      </div>
      {state.isLoading ? (
        <TablePlaceHolder />
      ) : (
        <>
          <div className="table-cont">
            <table id="forwardTable" className="yard-table">
              <thead>
                <tr className="table-header">
                  {headers.map((item, index) => (
                    <th key={index} scope="col">
                      {item}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {state.data.map((item, index) => (
                  <tr key={`index-${index}`} className="data-rows">
                    <td className="gray">{item.description}</td>
                    <td className="gray">{item.maintenance_report.unit}</td>
                    <td className="gray">
                      {item.maintenance_report.order_number}
                    </td>
                    <td className="gray">{convertToPST(item.created_at)}</td>
                    <td className="gray">{convertToPST(item.completed_at)}</td>
                    <td className="gray">
                      <GetVehicleCondition condition={item.status} />
                    </td>
                    <td className="gray">{item.assigned_mechanic.full_name}</td>
                    <td className="gray">{item.notes}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </PageLayout>
  );
};

export default MaintenanceTasksView;
